<template>
  <!-- Same display as the return candidates in "Product toevoegen" of the instruction processing -->
  <ComboboxRentalMutationGroupDisplay
    :item="rentalIntake"
    :flow-direction="RentalMutationFlowDirections.RETURN"
    is-list-item
  />
</template>

<script setup lang="ts">
import { computed, provide } from "vue"
import ComboboxRentalMutationGroupDisplay from "@/components/administration/combobox-display-templates/ComboboxRentalMutationGroupDisplay.vue"
import { RentalMutationFlowDirections } from "@/enums/rental-mutation-flow-directions"
import type { RentalIntake } from "@/models/rental-intake.model"
import type { Project } from "@/models/project.model"
import type { Instruction } from "@/models/instruction.model"

const props = defineProps<{
  rentalIntake: RentalIntake
  /** Project tagged in the text, highlighted like the instruction's project in the combobox. */
  taggedProject: Project | null
}>()

// The combobox displays read the instruction to flag items of another project. A mention has
// no instruction, so the tagged project takes its place; without one, nothing is flagged.
provide(
  "instruction",
  computed(
    () => ({ project: props.taggedProject ?? props.rentalIntake.project }) as unknown as Instruction
  )
)
</script>
